import { keyframes, styled } from '@mui/system';
import { COLORS } from './colors';
import theme from '../../../components/App/theme';

const fadeIn = keyframes`
  from {
    box-shadow: 0 0 5px 0 ${COLORS.brand[100]};
    border-color: 2px solid ${COLORS.brand[100]};
    background-color: ${COLORS.black[60]};
  }
  to {
    box-shadow: 0 0 8px 0 transparent;
    border-color: 2px solid transparent;
    background-color: ${COLORS.black[80]};
  }
`;

export const GraphCards = styled('div')(({ theme: { spacing } }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: spacing(2),
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

interface GraphCardContainerProps {
  isSelectedMetric: boolean;
}
export const GraphCardContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSelectedMetric',
})<GraphCardContainerProps>(({ theme: { spacing }, isSelectedMetric }) => ({
  padding: spacing(3),
  backgroundColor: COLORS.black[80],
  borderRadius: spacing(1.5),
  columnGap: spacing(1.5),
  boxShadow: `0 0 8px 0 transparent`,
  border: `1px solid transparent`,
  animation: isSelectedMetric ? `${fadeIn} 1s ease-in-out` : 'none',
}));

export const GraphCardTitle = styled('div')(({ theme: { spacing } }) => ({
  fontWeight: 500,
  fontSize: 16,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: COLORS.white[50],
  lineHeight: '135%',
  marginBottom: spacing(1),
}));

export const GraphCardMeta = styled('div')(({ theme: { spacing } }) => ({
  display: 'grid',
  gridTemplateColumns: '100%',
  columnGap: spacing(1.5),
  alignItems: 'center',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '40% 60%',
  },
}));

export const GraphCardTotal = styled('div')({
  fontWeight: 400,
  fontSize: 28,
});

export const GraphCardCount = styled('span')({
  fontWeight: 400,
  fontSize: 20,
});

export const GraphCardInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const GraphCardDescription = styled('div')(({ theme: { spacing } }) => ({
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '135%',
  marginBottom: spacing(0.5),
}));

export const GraphCardDelta = styled('div')({
  display: 'flex',
  columnGap: 4,
  alignItems: 'center',
  fontWeight: 400,
  fontSize: 12,
  '& .pos, & .neg, & .no-improvements': {
    fontWeight: 700,
  },
  '& .pos': {
    color: COLORS.color_blind_friendly.best,
  },
  '& .neg': {
    color: COLORS.color_blind_friendly.worst,
  },
  '& .no-improvements': {
    color: COLORS.color_blind_friendly.middle,
  },
});

export const GraphCardChart = styled('div')({
  position: 'relative',
});

export const GraphCardChartDisclaimer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.7)',
  backdropFilter: 'blur(1px)',
  '&:after': {
    content: '"No data available for the selected timeframe"',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    textAlign: 'center',
    width: '80%',
  },
});

export const GraphCardNotes = styled('div')(({ theme: { spacing } }) => ({
  fontSize: '13px',
  marginTop: spacing(1),
}));
